export default "__VITE_ASSET__9_3CgMw4__"